<script setup lang="ts">
import ResetPasswordForm from '@/v2/shared/components/auth/ResetPasswordForm.vue'
import AuthLayout from '@/v2/shared/layouts/auth/AuthLayout.vue'
import { Link } from '@inertiajs/vue3'
import { route } from 'ziggy-js'

defineProps<{
    email: string
    token: string
}>()
</script>

<template>
    <AuthLayout title="Reset Password">
        <template #header-action>
            Remember your password?
            <Link
                :href="route('login')"
                class="underline decoration-from-font underline-offset-2"
            >
                Log in
            </Link>
        </template>

        <ResetPasswordForm :email="email" :token="token" />
    </AuthLayout>
</template>
